import { jsx as _jsx } from "react/jsx-runtime";
import { AccordionItem, forwardRef, } from '@chakra-ui/react';
import { NumberedAccordionItemContext } from './context';
export const NumberedAccordionItem = forwardRef(({ children, ...otherProps }, ref) => {
    return (_jsx(AccordionItem, { ref: ref, ...otherProps, children: ({ isExpanded, isDisabled }) => {
            return (_jsx(NumberedAccordionItemContext.Provider, { value: { isExpanded, isDisabled }, children: typeof children === 'function'
                    ? children({
                        isExpanded,
                        isDisabled,
                    })
                    : children }));
        } }));
});
